module.exports = __webpack_public_path__ + "static/media/11NEPAD6.8413205c.jpg";